import { useEffect, useRef } from 'react';

const SEARCH_BAR_ABOVE_TILES_SELECTOR =
	'[data-widget-name="ws-locations-control"]';

const getMobileAbsoluteTop = (element) =>
	element.getBoundingClientRect().top + window.scrollY;

const usePaginationScroll = (currentPage, isMobile = false, offset = 20) => {
	const scrollTargetRef = useRef(null);
	const isFirstLoad = useRef(true);

	useEffect(() => {
		if (isFirstLoad.current) {
			isFirstLoad.current = false;
			return;
		}

		if (isMobile) {
			// Mobile: scroll to the control widget (search bar) so the user sees the updated results from the top
			const controlWidget = document.querySelector(
				SEARCH_BAR_ABOVE_TILES_SELECTOR
			);
			const targetElement = controlWidget || scrollTargetRef.current;

			if (!targetElement) return;

			window.scrollTo({
				top: getMobileAbsoluteTop(targetElement) - offset,
				behavior: 'smooth'
			});
		} else {
			if (!scrollTargetRef.current) return;

			const containerTop = scrollTargetRef.current.offsetTop;

			window.scrollTo({
				top: containerTop - offset,
				behavior: 'smooth'
			});
		}
	}, [currentPage, isMobile, offset]);

	return { scrollTargetRef };
};

export default usePaginationScroll;
